import React, { Component } from 'react';
import { Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import Breadcrumbs, { textResolver } from 'react-router-breadcrumbs';
import { Link } from 'react-router';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Footer, TopHeader, Logout, Navigation } from '../common';
import { layoutHelper } from '../layouts';
import { titleize } from '../../utils/helpers/text_formatters';

class Ssp extends Component {

    componentDidMount() {
        layoutHelper();
    }

   render() {
        const { 
            user, 
            dispatch, 
            navItems, 
            websites, 
            routes, 
            routeParams, 
            location 
        } = this.props;

        const slug = get(routeParams, 'websiteSlug');
        const pathname = get(location, 'pathname');

        const title = (
            (websites.data || []).filter(e => e.slug === slug)[0] || {}
        ).name || 'Websites';
        
        const sites = websites.data || [];

        const navLeft = (
            <Nav className='navbar-top-links'>
                <NavDropdown 
                    eventKey={1} 
                    title={title} 
                    id="basic-nav-dropdown" 
                    href='javascript:void(0);'
                > 
                    {sites.map((w, i) => {
                        const path = `/ssp/websites/${w.slug}/dashboard`;
                        return (
                            <MenuItem
                                key={`website-${i}`} 
                                href='javascript:void(0);' 
                                onClick={() => dispatch(push(path))}
                            >
                                {w.name}
                            </MenuItem>        
                        );
                    })}
                    {pathname !== '/ssp/websites' ? 
                        <MenuItem 
                            href='javascript:void(0);' 
                            onClick={() => dispatch(push('/ssp/websites'))}
                        >
                            All Websites
                        </MenuItem> : null
                    }
                </NavDropdown>
            </Nav>
        );

        const navRight = (
            <Nav pullRight className='navbar-top-links'>
                <NavDropdown 
                    eventKey={1} 
                    title={user.name || 'Me'} 
                    id="basic-nav-dropdown" 
                    href='javascript:void(0);'
                > 
                    <MenuItem 
                        href='javascript:void(0);' 
                        onClick={() => dispatch(push('/ssp/settings'))}
                    >
                        User Settings
                    </MenuItem>
                    {user.isAdmin ? 
                        <MenuItem 
                            href='javascript:void(0);' 
                            onClick={() => dispatch(push('/admin'))}
                        >
                            Admin
                        </MenuItem> : null
                    }
                    <Logout />
                </NavDropdown>
            </Nav>
        );

        const CustomLink = (link, key, text, index, routers) => {
            const isLastElement = index === routers.length - 1;
            const cls = isLastElement ? '' : 'active';
            return (
                <li key={key}>
                    <Link to={link} className={cls}>{titleize(text)}</Link>
                </li>
            );
        };

        return (
            <div id='wrapper'>
                {navItems ? <Navigation navItems={navItems} /> : null}
                <div 
                    id={navItems ? 'page-wrapper' : 'page-wrapper-main'} 
                    className='gray-bg'
                >
                    <TopHeader sideBtn>
                        {sites.length > 0 ? navLeft : null}
                        {navRight}
                    </TopHeader>
                    <div className={`wrapper wrapper-content${navItems ? '' : ' m-t-xxl'}`}>
                        <div className='m-b-md'>
                            <Breadcrumbs
                                resolver={textResolver}
                                routes={routes}
                                wrappingComponent={'ol'}
                                className={'breadcrumb'}
                                createLink={CustomLink}
                                params={routeParams}
                                createSeparator=''
                            />
                        </div>
                        {this.props.children}
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
 
}

const mapStateToProps = (state) => {
    const { user, ssp: { websites } } = state;
    return {
        user: user.data,
        websites: websites.data
    };
};

export default connect(mapStateToProps)(Ssp);
